import React from 'react';
import { ChatPanelMarkdown } from './ChatPanelMarkdown';
import { ChatPanelMessageAttachments } from './ChatPanelMessageAttachments';
import { readAttachmentsFromMetadata } from './chatPanelAttachments';
import {
  formatPersonRecipientLabels,
  readPersonDeliveryMetadata,
} from './chatPanelPersonMessaging';
import styles from './ChatPanel.module.css';

export interface ChatPanelPersonMessageProps {
  text: string;
  metadata?: Record<string, unknown>;
}

export const ChatPanelPersonMessage: React.FC<ChatPanelPersonMessageProps> = ({ text, metadata }) => {
  const personDelivery = readPersonDeliveryMetadata(metadata);
  const recipientLabel = personDelivery
    ? formatPersonRecipientLabels(personDelivery.recipients)
    : null;
  const attachments = readAttachmentsFromMetadata(metadata);

  return (
    <div
      className={styles.messageBubble}
      data-testid="chat-person-message"
      data-delivery-mode={personDelivery ? 'person_deliver' : undefined}
    >
      <span className={styles.messageWho}>
        {recipientLabel ? `You → ${recipientLabel}` : 'You'}:
      </span>
      {text ? <ChatPanelMarkdown text={text} /> : null}
      <ChatPanelMessageAttachments attachments={attachments} />
    </div>
  );
};
